import TextPage from "./TextPage";

const Terms = () => {
    return (
        <TextPage>
            <h1 className="text-2xl font-bold mb-4  ">Terms and Conditions</h1>

            <h2 className="text-xl font-semibold mt-6 mb-2  ">App Usage Terms</h2>
            <p className="mb-4  ">
                Welcome to Ananas Calorie Tracker! By downloading or using the Spicy mobile application or accessing our
                website, you ("the user") agree to comply with the following terms and conditions. These
                terms and conditions form a legal agreement between you and the Ananas Calorie Tracker service (owned by the
                Ananas Calorie Tracker GROUP). If you do not agree with these terms, you should not use the Ananas Calorie Tracker app or
                website.
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Age Requirement and Eligibility</h3>
            <p className="mb-4  ">
                Ananas Calorie Tracker is intended for adult use. To create an account and use Ananas Calorie Tracker services, you must be at
                least 18 years old...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Legal Jurisdiction</h3>
            <p className="mb-4  ">
                Ananas Calorie Tracker is based in the United States and operates in accordance with U.S. laws and regulations.
                At this time we cannot accept users from the following countries:
                <br />
                • Cuba
                <br />
                • Iran
                <br />
                • North Korea
                <br />
                • Syria
                <br />
                • Russia
                <br />
                • Crimea, Donetsk, and Luhansk regions of Ukraine
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Account Creation</h3>
            <p className="mb-4  ">
                To gain full access to Ananas Calorie Tracker’s features, you need to create a personal account. Registration
                on Ananas Calorie Tracker is free...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Subscriptions and Payments</h3>
            <p className="mb-4  ">
                Installing and basic use of Ananas Calorie Tracker is free, and some features are available at no cost...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Medical and Health Disclaimer</h3>
            <p className="mb-4  ">
                Ananas Calorie Tracker is a tool for monitoring nutrition, exercise, and general health indicators, but it is
                not a substitute for medical services or professional advice...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Limitation of Liability</h3>
            <p className="mb-4  ">
                Ananas Calorie Tracker is provided to you on an "as-is" basis...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Intellectual Property Rights</h3>
            <p className="mb-4  ">
                All content, features, and technologies of Ananas Calorie Tracker belong to the Ananas Calorie Tracker GROUP and are protected
                under intellectual property laws...
            </p>

            <h3 className="text-lg font-medium mt-4 mb-1  ">Contact and Support</h3>
            <p className="mb-4  ">
                If you have any questions or concerns regarding these terms and conditions, please contact
                us via email at{" "}
                <a className="text-blue-400" href="mailto:privacy@ananas.site">
                    privacy@ananas.site
                </a>.
            </p>
        </TextPage>
    );
};

export default Terms;
